export default class Constants {
  public static TOKEN_EXPIRE_DAYS = 16;
  public static TOKEN_NAME = "";
  public static REFRESH_TOKEN_NAME = "";
  public static API_URL = "https://market-data.tvsi.com.vn";
  public static API_TRADING_URL = '/api/v1/Trading/';
  public static API_DASHBOARD_URL = "/api/v1/Dashboard/"
  public static API_EVENT_URL = Constants.API_URL + "/admin";
  public static TOTAL_ITEM_PER_PAGE = 10
  public static LOCAL_DASH_BOARD_CONFIG_NAME = "TVSI_DASHBOARD_CONFIG";
  public static TVSI_DASHBOARD_WATCHING_LIST = "TVSI_DASHBOARD_WATCHING_LIST"
  public static RATIO_DIMENSION = window.innerWidth / 1366
  public static EFFECT_UPDATE_TIME = 200
  public static NOCONTENT_IMAGE_DEFAULT = "/assets/icon/news_default.png"
  public static TIME_TO_REFRESH = 60000
}
